// extracted by mini-css-extract-plugin
export default {"toggleContainer":"s5-z","toggleBtn":"t5-z","toggleLabel":"u5-z","tooltipContainer":"v5-z","tooltipWrapper":"w5-z","tooltipContentTop":"x5-z"};